import React from 'react';
import { AppNextLink } from '@/features/app-next-link';
import { IconArrowSquareLeft } from '@/components/svg-symbols/icons';
interface Props {
  title: string;
  link: string;
}
function BoxLink({
  title,
  link
}: Props) {
  return <AppNextLink href={link} className='flex w-full items-center justify-between border-t border-border-gray-light py-4' data-sentry-element="AppNextLink" data-sentry-component="BoxLink" data-sentry-source-file="box-link.tsx">
            <span className='text-body-14 font-bold text-text-black lg:text-body-16'>{title}</span>
            <IconArrowSquareLeft className='h-6 w-6' data-sentry-element="IconArrowSquareLeft" data-sentry-source-file="box-link.tsx" />
        </AppNextLink>;
}
export default BoxLink;